import { useEffect, useCallback } from 'react';
import { auth } from '../config/firebaseConfig';
import dgEngineService from '../services/dgEngineService';

/**
 * useGPSLocation - 채팅방 입장 시 GPS 위치 수집 후 DG Engine에 전송
 * Firebase UID를 직접 참조하므로 userId prop 불필요
 */
export default function useGPSLocation() {
  const updateLocation = useCallback(async () => {
    const userId = auth.currentUser?.uid;
    if (!userId || !navigator.geolocation) return;

    navigator.geolocation.getCurrentPosition(
      async (pos) => {
        const uid = auth.currentUser?.uid;
        if (!uid) return;
        try {
          await dgEngineService.updateLocation(
            uid,
            pos.coords.latitude,
            pos.coords.longitude,
            pos.coords.accuracy
          );
          console.log('[GPS] 위치 업데이트 완료:', pos.coords.latitude, pos.coords.longitude);
        } catch (err) {
          console.warn('[GPS] update failed:', err.message);
        }
      },
      (err) => console.warn('[GPS] permission denied:', err.message),
      { enableHighAccuracy: true, timeout: 10000 }
    );
  }, []);

  // 채팅방 입장 시 1회 + 5분마다 갱신
  useEffect(() => {
    updateLocation();
    const interval = setInterval(updateLocation, 5 * 60 * 1000);
    return () => clearInterval(interval);
  }, [updateLocation]);

  return { updateLocation };
}
